import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface AppDownloadPromptState {
  hasDismissedAppPrompt: boolean;
  setHasDismissedAppPrompt: (value: boolean) => void;
}

export const useAppDownloadPromptStore = create<AppDownloadPromptState>()(
  persist<AppDownloadPromptState>(
    (set) => ({
      hasDismissedAppPrompt: false,
      setHasDismissedAppPrompt: (value) => set({ hasDismissedAppPrompt: value }),
    }),
    {
      name: "app-download-prompt",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
